import { Flex } from '@chakra-ui/react';
import React from 'react';

import { NavigationItem } from '@features/navigation/NavigationItem';
import { ToggleStateProvider } from '@features/navigation/ToggleStateProvider';
import { NavigationEntity, useMarketplaceNavigationEntities } from 'hooks/useNavigationEntities';

interface Props {
  onSelect?: (entity: NavigationEntity) => void;
}
const NavigationList = React.memo(({ onSelect }: Props) => {
  const { root, byId } = useMarketplaceNavigationEntities();

  return (
    <Flex flexDirection="column">
      {root.children.map((child) => {
        const entity = byId[child.id];
        if (entity == null) {
          return null;
        }
        return <NavigationItem key={`${entity.id}`} entity={entity} onSelect={onSelect} />;
      })}
    </Flex>
  );
});

export const PageNavigation = React.memo(({ onSelect }: Props) => {
  return (
    <ToggleStateProvider>
      <NavigationList onSelect={onSelect} />
    </ToggleStateProvider>
  );
});

PageNavigation.displayName = 'PageNavigation';
